import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/charging-station.png'

function EvChargerNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Ev Charger Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>EV Charger</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default EvChargerNode
